// extracted by mini-css-extract-plugin
export var active = "_2e-9";
export var backButton = "_2e-8";
export var clone = "_2e-e";
export var collapseBar = "_2e-k";
export var collapseMode = "_2e-m";
export var collapsed = "_2e-o";
export var dimmed = "_2e-i";
export var dragHandle = "_2e-c";
export var dropdownIcon = "_2e-g";
export var expanding = "_2e-n";
export var hidden = "_2e-x";
export var iconContainer = "_2e-q";
export var iconSwapper = "_2e-w";
export var navItem = "_2e-6";
export var navItemIcon = "_2e-f";
export var navProfile = "_2e-7";
export var notificationCountBadge = "_2e-j";
export var notificationDot = "_2e-r";
export var optionsContainer = "_2e-h";
export var primaryNav = "_2e-0";
export var primaryNavDivider = "_2e-v";
export var primaryNavResizeHandle = "_2e-2";
export var primaryNavResizing = "_2e-1";
export var primaryNavTabSection = "_2e-u";
export var primaryTab = "_2e-p";
export var primaryTabIconBox = "_2e-s";
export var secondaryNav = "_2e-3";
export var selected = "_2e-t";
export var settingsNav = "_2e-4";
export var settingsNavItems = "_2e-5";
export var show = "_2e-d";
export var sideNav = "_2e-l";
export var teamItem = "_2e-a";
export var userProfileItem = "_2e-b";